import { HeroSection } from '../components/HeroSection';
import { CountdownTimer } from '../components/CountdownTimer';
import { VideoSection } from '../components/VideoSection';
import { EventCards } from '../components/EventCards';
import { ProtocolSection } from '../components/ProtocolSection';
import { PhotoGallery } from '../components/PhotoGallery';
import { DressCode } from '../components/DressCode';
import { GiftRegistry } from '../components/GiftRegistry';
import { GuestBook } from '../components/GuestBook';
import { Footer } from '../components/Footer';

export function WeddingHome() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--butter)' }}>
      <HeroSection />
      <CountdownTimer />
      <section
        className="min-h-[20vh] md:min-h-[25vh]"
        style={{ backgroundColor: '#FFFFF0' }}
        aria-hidden
      />
      <VideoSection />
      <EventCards />
      <ProtocolSection />
      <DressCode />
      <GiftRegistry />
      <GuestBook />
      <PhotoGallery />
      <Footer />
    </div>
  );
}
